import { ContactsList } from './ContacstList'
import {Form} from './Form'


export const Component = { ContactsList, Form }